import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, NgModule } from '@angular/core';
import { BreakpointsService } from '@core/services/breakpoints/breakpoints.service';
import { environment } from '@environment';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { ImaginarySrcModule } from '@wizbii/angular-utilities';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

@UntilDestroy()
@Component({
  selector: 'app-cej-v2-what-is-it',
  templateUrl: './cej-v2-what-is-it.component.html',
  styleUrls: ['./cej-v2-what-is-it.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CejV2WhatIsItComponent {
  desktopIllustration$ = this.isMobile$.pipe(
    untilDestroyed(this),
    filter((isMobile) => !isMobile),
    map(() => ({
      src: `${environment.wizbiiImages}/cejv2/what-it-is.png`,
      width: 527,
    }))
  );

  mobileIllustration$ = this.isMobile$.pipe(
    untilDestroyed(this),
    filter((isMobile) => isMobile),
    map(() => ({
      src: `${environment.wizbiiImages}/cejv2/mobile-what-it-is.png`,
      width: 350,
    }))
  );

  get isMobile$(): Observable<boolean> {
    return this.breakpointsService.isMobile$;
  }

  constructor(private readonly breakpointsService: BreakpointsService) {}
}
@NgModule({
  imports: [CommonModule, ImaginarySrcModule],
  declarations: [CejV2WhatIsItComponent],
  exports: [CejV2WhatIsItComponent],
})
export class CejV2WhatIsItModule {}
